import { render, staticRenderFns } from "./product-configure.html?vue&type=template&id=962e173e&scoped=true&"
import script from "./product-configure.js?vue&type=script&lang=js&"
export * from "./product-configure.js?vue&type=script&lang=js&"
import style0 from "./product-configure.scss?vue&type=style&index=0&id=962e173e&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=962e173e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962e173e",
  null
  
)

export default component.exports